export class QuestionsDeleteRequest {
  resolutionId!: string
  questionId!: string
  constructor(resolutionId:string, questionId:string) {
    this.resolutionId = resolutionId
    this.questionId = questionId
  }
}
